import useRollbarUtil from "@/components/hooks/useRollbarUtil";
import { useAlertsQuery } from "@/generated/graphql_billing";

export const useAlerts = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();

  const { loading, data, refetch } = useAlertsQuery({
    onError: getNotifyErrorHandlerForGraphQL("error fetching alerts"),
    context: {
      api: "billing",
    },
  });

  const alerts = data?.alerts || [];

  return {
    alerts,
    alertsLoading: loading,
    alertsRefetch: refetch,
  };
};
